import React from "react";
import bgImage from "../../assets/news-bg.png";

export default function WatchNowNews() {
  return (
    <section
      className="w-full  py-20 px-6 bg-cover bg-center relative flex flex-col items-center justify-center select-none"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      {/* Dark overlay to ensure contrast */}
      <div className="absolute inset-0 bg-black/70 pointer-events-none"></div>

      <div className="relative z-10 text-center flex flex-col items-center">
        {/* Title */}
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold font-oswald text-white tracking-widest uppercase mb-8 drop-shadow-[0_2px_10px_rgba(255,140,33,0.35)] animate-pulse">
          WATCH NOW
        </h2>

        {/* Button */}
        <button className="px-10 py-3.5 bg-secondary text-black font-bold font-outfit text-sm uppercase tracking-widest rounded-md hover:bg-white hover:text-black hover:shadow-lg hover:shadow-secondary/20 transition-all duration-300 active:scale-95 outline-none focus:outline-none">
          Subscribe
        </button>
      </div>
    </section>
  );
}
